import { Head } from '@inertiajs/react'
import { DealsTable } from "@/components/deals-table"

export default function Expiring() {
  return (
    <>
      <Head title="Expiring Deals" />
      <DealsTable title="Expiring Deals" subtitle="Expiring in the next 90 days" />
    </>
  )
}
